import { render, staticRenderFns } from "./itemInformation.vue?vue&type=template&id=ef608e50&scoped=true"
import script from "./itemInformation.vue?vue&type=script&lang=js"
export * from "./itemInformation.vue?vue&type=script&lang=js"
import style0 from "./itemInformation.vue?vue&type=style&index=0&id=ef608e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef608e50",
  null
  
)

export default component.exports